<template>
  <div id="navbar-header">
    <MobileDrawer @click="toggler = !toggler" :toggler="toggler" />

    <div class="navbar" id="navbar" :class="{ change_color: scrollPosition > 50 }">
      <v-container id="container">
        <div class="nav" id="nav">
          <router-link
            class="navbar-logo"
            id="navbar-logo"
            :class="{ change_color: scrollPosition > 50 }"
            :to="'/'"
            tag="div"
          >
            <img
              v-if="scrollPosition > 50"
              src="@/assets/logo-white.png"
              alt="brand-logo"
              class="nav-logo-image"
            />
            <img
              src="@/assets/logo-black.png"
              alt="brand-logo"
              v-else
              class="nav-logo-image"
              id="nav-logo-image"
            />
          </router-link>
          <!-- <router-link class="nav-logo" :to="'/'" tag="div"> -->
          <!-- <img
              src="@/assets/logo-white.png"
              alt="brand-logo"
              class="nav-logo-image"
            /> -->
          <!-- </router-link> -->
          <div class="nav-menu" id="nav-menu" v-if="!user">
            <ul class="nav-menu-links" id="nav-menu-links">
              <!-- <router-link
                id="home-link"
                :to="'/'"
                exact
                active-class="nav-active"
                tag="li"
                :class="getClass"
              >
                {{ $t("home") }}
              </router-link> -->
              <a
                id="about-link"
                :href="'https://routeline.com/pages/about'"
                exact
                active-class="nav-active"
                tag="li"
                :class="getClass"
              >
                <!-- {{ $t("about") }} -->
                What is Route Line
              </a>
              <a
                id="membership-link"
                :class="getClass"
                exact
                :href="'https://welcometorouteline.com/'"
                active-class="nav-active"
                tag="li"
                v-if="!isMember"
              >
                {{ $t("membership") }}
              </a>
              <a
                id="vehicle-link"
                :href="'https://routeline.com/pages/our-fleet'"
                exact
                active-class="nav-active"
                tag="li"
                :class="getClass"
              >
                {{ $t("vehicles") }}
              </a>
              <a
                id="Gear-link"
                :href="'https://routeline.com/collections/shop'"
                exact
                active-class="nav-active"
                tag="li"
                :class="getClass"
              >
                <!-- {{ $t("vehicles") }} -->
                Gear
              </a>
              <!-- <v-menu open-on-hover>
                <template v-slot:activator="{ on, attrs }">
                  <router-link
                    id="vehicle-link"
                    :class="getClass"
                    :to="'/vehicles'"
                    active-class="nav-active"
                    tag="li"
                  >
                    <span v-bind="attrs" v-on="on">{{ $t("vehicles") }}</span>
                  </router-link>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn :to="'/vehicle-type/ovp4'" tag="div">
                        Four Person Van
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn :to="'/vehicle-type/ovp2'" tag="div">
                        Two Person Van
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn :to="'/vehicle-type/camper'" tag="div">
                        Campers
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn :to="'/vehicle-type/taxa'" tag="div">
                        Trailers
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu> -->
              <!-- <router-link
                id="vehicle-link"
                :class="getClass"
                :to="'/vehicles'"
                active-class="nav-active"
                tag="li"
              >
                {{ $t("vehicles") }}
              </router-link> -->
            </ul>
          </div>
          <div class="nav-button" id="nav-button">
            <v-btn
              rounded
              class="pl-5 pr-5"
              color="secondary"
              v-if="!user"
              :to="'/login'"
              id="create-account"
            >
              Create Account/Sign-in
            </v-btn>
            <v-menu offset-y v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary-color" id="account-name" :class="{ change_color: scrollPosition > 50 }"  v-bind="attrs" v-on="on" text>
                  <v-icon>mdi-account</v-icon> {{ getDisplayName }}
                </v-btn>
              </template>
              <v-list class="pa-0">
                <v-list-item class="pa-1 pt-0 pb-0" id="profile-list">
                  <v-btn text color="primary" to="/profile" dark id="profile-btn">
                    Profile
                  </v-btn>
                </v-list-item>
                <v-list-item class="pa-1 pt-0 pb-0" id="trip-list">
                  <v-btn text color="primary" to="/trips" dark id="trip-btn"> Trips </v-btn>
                </v-list-item>
                <v-list-item class="pa-1 pt-0 pb-0" id="logout-list">
                  <v-btn text color="primary" dark @click="$root.logout()" id="logout-btn">
                    Logout
                  </v-btn>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <!-- for mobile screen only -->

          <button @click="toggler = !toggler" :class="getTogglerClass">
            &nbsp;
          </button>

          <!-- end -->
        </div>
      </v-container>

      <!-- <router-link class="navbar-logo" :class="{change_color: scrollPosition > 50}" :to="'/'" tag="div">
        <img
          src="@/assets/logo-white.png"
          alt="brand-logo"
          class="nav-logo-image"
        />
      </router-link> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import Button from "../buttons/Button.vue";
import MobileDrawer from "./MobileDrawer.vue";

export default {
  data: () => ({
    toggler: false,
    scrollPosition: null,
  }),
  components: {
    // Button,
    MobileDrawer,
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    getTogglerClass() {
      return this.toggler ? "nav-button-mobile-active" : "nav-button-mobile";
    },
    getClass() {
      return this.scrollPosition > 50 ? "nav-menu-links-link text-color" : "nav-menu-links-link";
    },
    getDisplayName() {
      return this.user?.displayName?.split(" ")[0] ?? "";
    },
    isMember() {
      return !!this.user?.member;
    },
  },
  created() {
    this.updateScroll();
  },
  mounted() {
    // this.updateScroll();
    window.addEventListener("scroll", this.updateScroll);
  },
  methods: {
    updateScroll() {
      // console.log( this.$route.name);
      // get route and mange with it
      this.$route.fullPath === "/"
        ? (this.scrollPosition = window.scrollY)
        : (this.scrollPosition = 100);
      // this.scrollPosition = window.scrollY;
    },
  },
  watch: {
    $route() {
      this.toggler = false;
      this.updateScroll();
    },
  },
};
</script>

<style scoped lang="scss">
.change_color {
  background-color: var(--primary-color);
  color: white;
}
.text-color {
  color: var(--light) !important;
}
.navbar {
  position: fixed;
  overflow: hidden;
  top: 0;
  // gray color gradient

  // background-color: rgba#97989C;
  // background-color: rgba(0, 0, 0, 0.1);
  color: var(--light);
  width: 100%;
  padding: 12px 0;
  z-index: 100;
  font-weight: 400;
  font-size: 18px;

  &-logo {
    // background: var(--primary-color);
    // background-color: rgba(0, 0, 0, 0.1);
    // position: absolute;
    // top: 0;
    // left: 0;
    // bottom: 0;
    // width: 540px;
    display: flex;
    align-items: center;
    justify-content: center;
    // z-index: 2;
    // clip-path: polygon(0 0, 100% 0, 81% 100%, 0% 100%);
    cursor: pointer;

    &-image {
      width: 100px;
      height: 100px;
      margin-bottom: 12px;
    }
  }
}
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &-button-mobile {
    display: none;
    position: relative;
    padding: 10px;
    height: 10px;
    // background: var(--light);

    &::before {
      content: "";
      width: 30px;
      border-top: 4px solid var(--red-color);
      position: absolute;
      top: 0;
      right: 0;
      background: var(--red-color);
      transition: all 0.3s ease-in-out;
    }
    &::after {
      content: "";
      width: 30px;
      border-bottom: 4px solid var(--red-color);
      position: absolute;
      bottom: 0;
      right: 0;
      background: var(--red-color);
      transition: all 0.3s ease-in-out;
    }
  }
  &-button-mobile-active {
    display: none;
    position: relative;
    padding: 10px;
    height: 10px;
    // background: var(--light);

    &::before {
      content: "";
      width: 30px;
      border-top: 4px solid var(--red-color);
      position: absolute;
      top: 8px;
      right: 0;
      background: var(--red-color);
      transition: all 0.3s ease-in-out;
      transform: rotate(45deg);
    }
    &::after {
      content: "";
      width: 30px;
      border-bottom: 4px solid var(--red-color);
      position: absolute;
      bottom: 8px;
      right: 0;
      background: var(--red-color);
      transition: all 0.3s ease-in-out;
      transform: rotate(-45deg);
    }
  }
  &-logo {
    cursor: pointer;

    &-image {
      width: 130px;
    }
  }
  &-menu {
    transition: all 0.3s ease;
    &-links {
      display: flex;
      column-gap: 45px;

      &-link {
        list-style-type: none;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        color: var(--primary-color);
        text-decoration: none;

        &:hover {
          color: var(--primary-color);
          text-decoration: none;
        }

        &::after {
          position: absolute;
          content: "";
          display: block;
          width: 0;
          height: 2px;
          background: var(--red-color);
          transition: all 0.3s ease;
        }

        &:hover::after {
          position: absolute;
          content: "";
          display: block;
          width: 100%;
          height: 2px;
          background: var(--red-color);
          transition: all 0.3s ease;
        }
      }
    }
  }
  &-button {
    display: flex;
    align-items: center;
    column-gap: 20px;
    transition: all 0.3s ease;

    &-image {
      width: 35px;
      cursor: pointer;
    }
  }

  &-active {
    color: var(--primary-color);

    &::after {
      position: absolute;
      content: "";
      display: block;
      width: 100%;
      height: 2px;
      background: var(--red-color);
      transition: all 0.3s ease;
    }
  }
}

@media screen and (max-width: 1100px) {
  .nav {
    &-button {
      display: none;
    }
    &-menu {
      display: none;
    }
    &-button-mobile {
      display: inline-block;
    }
    &-button-mobile-active {
      display: inline-block;
    }
  }
}
</style>
